module.exports = __webpack_public_path__ + "img/6_windAndRain_wxc.f5f385a6.png";